<template>
  <div>
    <v-select
      box
      flat
      success
      label="Credor"
      item-text="name"
      item-value="creditor_id"
      :disabled="disabled"
      :loading="loading"
      :hint="hint"
      :items="creditors"
      :multiple="multiple"
      :clearable="clearable"
      :class="hint == 'none' ? 'text-details-none' : ''"
      v-model="selectedCreditors"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="!multiple" class="text-no-wrap text-truncate">{{
          item.name
        }}</span>
        <div v-else>
          <span v-if="index === 0 && item.creditor_id !== -1" class="pr-1">
            {{ item.name }}
          </span>
          <span v-else-if="item.creditor_id === -1" class="pr-1">
            {{ getSelectedCreditorName(selectedCreditors[1]) }}
          </span>
          <span v-if="index === 1" class="grey--text caption">
            (+{{
              selectedCreditors.length -
              1 +
              (selectedCreditors.length == 2 ? " outro)" : " outros)")
            }}
          </span>
        </div>
      </template>

      <template v-slot:item="{ item, attrs, on }">
        <v-list-tile-action v-on="on" v-bind="attrs" v-if="multiple">
          <v-checkbox
            v-on="on"
            v-bind="attrs"
            :input-value="isSelected(item.creditor_id)"
            color="primary"
          ></v-checkbox>
        </v-list-tile-action>
        <v-list-tile-content v-on="on" v-bind="attrs" style="width: 100%">
          <span class="text-no-wrap">
            <span v-if="showIds && item.creditor_id !== -1" class="grey--text">
              {{ "#" + item.creditor_id }}&nbsp;
            </span>
            {{ item.name }}
          </span>
        </v-list-tile-content>
      </template>

      <template v-slot:append-item>
        <v-divider class="mb-2"></v-divider>
        <v-list-tile>
          <v-btn block flat color="primary" @click="goToCreditorsInfo()">
            Mais informações
          </v-btn>
        </v-list-tile>
      </template>
    </v-select>
  </div>
</template>

<script>
import creditorService from "@/services/creditor";

export default {
  props: {
    disabled: {
      default() {
        return false;
      },
    },
    selected: {
      default() {
        return [];
      },
    },
    multiple: {
      default() {
        return true;
      },
    },
    negotiation: {
      default() {
        return false;
      },
    },
    hint: {
      default() {
        return "none";
      },
    },
    clearable: {
      default() {
        return true;
      },
    },
    active: {
      default() {
        return true;
      },
    },
    order: {
      default() {
        return "id";
      },
    },
    showIds: {
      default() {
        return true;
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creditors: [],
      selectedCreditors: [],
    };
  },
  async created() {
    await this.getCreditors();
    if (this.multiple) {
      this.selected.forEach((id) => {
        this.creditors.forEach((el) => {
          if (id == el.creditor_id) this.selectedCreditors.push(el.creditor_id);
        });
      });
    } else if (this.selected) {
      this.selectedCreditors = parseInt(this.selected);
    }
  },
  watch: {
    selectedCreditors: {
      handler(newVal, oldVal) {
        if (!this.multiple) {
          this.$emit("selectedCreditors", newVal);
          return;
        }

        const selectAll = newVal
          .filter((c) => !oldVal.includes(c))
          .includes(-1);
        const unselectAll = !newVal.includes(-1) && oldVal.includes(-1);

        if (selectAll) {
          this.selectedCreditors = this.creditors.map((c) => c.creditor_id);
        } else if (unselectAll) {
          this.selectedCreditors = [];
        } else {
          this.$emit(
            "selectedCreditors",
            newVal.filter((c) => c !== -1),
          );
        }
      },
    },
    selected() {
      if (this.multiple) {
        this.selected.forEach((id) => {
          this.creditors.forEach((el) => {
            if (this.selectedCreditors.indexOf(el.creditor_id) === -1) {
              if (id == el.creditor_id)
                this.selectedCreditors.push(el.creditor_id);
            }
          });
        });
      } else {
        this.selectedCreditors = parseInt(this.selected);
      }
    },
  },
  methods: {
    getSelectedCreditorName(creditorId) {
      const creditor = this.creditors.find(
        (el) => el.creditor_id == creditorId,
      );
      return creditor ? creditor.name : "";
    },
    async getCreditors() {
      await creditorService
        .list({
          active: this.active,
          negotiation: this.negotiation,
          order: this.order,
        })
        .then((res) => {
          this.creditors = res.objects.sort((a, b) => {
            if (a.creditor_id < b.creditor_id) return -1;
            if (a.creditor_id > b.creditor_id) return 1;
            return 0;
          });

          if (this.creditors.length > 1 && this.multiple)
            this.creditors.unshift({
              name: "Selecionar todos",
              creditor_id: -1,
            });
          this.emitCreditors();
        })
        .catch((err) => console.error(err));
    },
    isSelected(id) {
      return this.selectedCreditors.filter((sc) => sc == id).length > 0;
    },

    goToCreditorsInfo() {
      this.$router.push({
        name: "Informações Dos Credores",
      });
    },
    emitCreditors() {
      this.$emit("creditorsList", this.creditors);
    },
  },
};
</script>

<style scoped lang="scss"></style>
